import React from 'react';

const ActivityIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10278_80194)">
      <path
        d="M17.8182 7.09093C18.1193 7.09093 18.3636 6.84655 18.3636 6.54546V3.8182C18.3636 2.916 17.6295 2.18184 16.7273 2.18184H15.8082C15.194 0.894018 13.8827 0 12.3637 0H8.00004C6.48093 0 5.16969 0.894018 4.55549 2.18184H3.63636C2.73417 2.18184 2 2.916 2 3.8182V22.3637C2 23.2659 2.73417 24.0001 3.63636 24.0001H16.7273C17.6295 24.0001 18.3636 23.2659 18.3636 22.3637V19.6364C18.3636 19.3353 18.1193 19.0909 17.8182 19.0909C17.5171 19.0909 17.2727 19.3353 17.2727 19.6364V22.3636C17.2727 22.6642 17.0278 22.9091 16.7272 22.9091H3.63636C3.33584 22.9091 3.09089 22.6642 3.09089 22.3636V3.8182C3.09089 3.51762 3.33584 3.27273 3.63636 3.27273H4.22546C4.19984 3.45166 4.18184 3.63273 4.18184 3.8182V4.90909C4.18184 5.21019 4.42622 5.45457 4.72731 5.45457H15.6364C15.9375 5.45457 16.1819 5.21019 16.1819 4.90909V3.8182C16.1819 3.63273 16.1639 3.45166 16.1382 3.27273H16.7273C17.0278 3.27273 17.2728 3.51762 17.2728 3.8182V6.54546C17.2728 6.84655 17.5171 7.09093 17.8182 7.09093ZM15.0909 4.36362H5.27273V3.8182C5.27273 2.31438 6.49617 1.09094 7.99999 1.09094H12.3636C13.8674 1.09094 15.0909 2.31438 15.0909 3.8182V4.36362H15.0909Z"
        fill="#2C2543"
      />
      <path
        d="M10.1822 3.27258C10.4834 3.27258 10.7277 3.02837 10.7277 2.72711C10.7277 2.42586 10.4834 2.18164 10.1822 2.18164C9.88093 2.18164 9.63672 2.42586 9.63672 2.72711C9.63672 3.02837 9.88093 3.27258 10.1822 3.27258Z"
        fill="#2C2543"
      />
      <path
        d="M14.5452 7.0918H5.81793C5.51684 7.0918 5.27246 7.33618 5.27246 7.63727C5.27246 7.93836 5.51684 8.18269 5.81793 8.18269H14.5452C14.8463 8.18269 15.0907 7.93831 15.0907 7.63722C15.0907 7.33613 14.8463 7.0918 14.5452 7.0918Z"
        fill="#2C2543"
      />
      <path
        d="M11.8179 9.81836H5.81793C5.51684 9.81836 5.27246 10.0627 5.27246 10.3638C5.27246 10.6649 5.51684 10.9093 5.81793 10.9093H11.8179C12.119 10.9093 12.3634 10.6649 12.3634 10.3638C12.3634 10.0627 12.119 9.81836 11.8179 9.81836Z"
        fill="#2C2543"
      />
      <path
        d="M11.2724 12.5469H5.81793C5.51684 12.5469 5.27246 12.7913 5.27246 13.0923C5.27246 13.3934 5.51684 13.6378 5.81793 13.6378H11.2725C11.5736 13.6378 11.818 13.3934 11.818 13.0923C11.8179 12.7913 11.5735 12.5469 11.2724 12.5469Z"
        fill="#2C2543"
      />
      <path
        d="M14.5458 18H10.1822C9.8811 18 9.63672 18.2444 9.63672 18.5455C9.63672 18.8466 9.8811 19.0909 10.1822 19.0909H14.5458C14.8469 19.0909 15.0913 18.8466 15.0913 18.5455C15.0913 18.2444 14.8469 18 14.5458 18Z"
        fill="#2C2543"
      />
      <path
        d="M7.99972 18H5.81788C5.51684 18 5.27246 18.2444 5.27246 18.5455C5.27246 18.8466 5.51684 19.0909 5.81793 19.0909H7.99977C8.30086 19.0909 8.54524 18.8466 8.54524 18.5455C8.54519 18.2444 8.30081 18 7.99972 18Z"
        fill="#2C2543"
      />
      <path
        d="M11.8179 15.2734H5.81793C5.51684 15.2734 5.27246 15.5178 5.27246 15.8189C5.27246 16.12 5.51684 16.3643 5.81793 16.3643H11.8179C12.119 16.3643 12.3634 16.12 12.3634 15.8189C12.3634 15.5178 12.119 15.2734 11.8179 15.2734Z"
        fill="#2C2543"
      />
      <path
        d="M17.8183 8.18164C15.1117 8.18164 12.9092 10.3842 12.9092 13.0907C12.9092 15.7973 15.1117 17.9998 17.8183 17.9998C20.5248 17.9998 22.7274 15.7973 22.7274 13.0907C22.7274 10.3842 20.5248 8.18164 17.8183 8.18164ZM17.8183 16.9089C15.7128 16.9089 14.0001 15.1962 14.0001 13.0907C14.0001 10.9852 15.7128 9.27253 17.8183 9.27253C19.9238 9.27253 21.6365 10.9853 21.6365 13.0907C21.6365 15.1962 19.9238 16.9089 17.8183 16.9089Z"
        fill="#2C2543"
      />
      <path
        d="M19.7355 10.988C19.4769 10.8331 19.142 10.9165 18.9871 11.1751L17.7102 13.3034L16.568 12.1612C16.3547 11.948 16.01 11.948 15.7967 12.1612C15.5834 12.3745 15.5834 12.7192 15.7967 12.9325L17.4331 14.5689C17.5351 14.6714 17.6742 14.7282 17.8182 14.7282C17.8405 14.7282 17.8629 14.7271 17.8847 14.7244C18.0516 14.7036 18.1994 14.6076 18.2856 14.4636L19.922 11.7364C20.0775 11.4778 19.9934 11.1429 19.7355 10.988Z"
        fill="#2C2543"
      />
    </g>
    <defs>
      <clipPath id="clip0_10278_80194">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ActivityIcon;
